export enum ESellerId {
  MASSIVE = "665bf650-48ff-4edf-b47f-d72860074c1f",
  INBOUND = "db958b36-1b65-4ca0-97f6-3fa68de06908",
  OUTBOUND = "d435b01f-d314-4f64-8cdd-d340f6162876",
}
